import { CategoryCountDto } from "@swagger/typescript-fetch-goflyer";
import { TFunction } from "i18next";
import { messages } from "../../../locales/messages";

export function getCategoryTooltip(
  category: CategoryCountDto,
  t: TFunction,
): string {
  if (category.frontPageCount > 0) {
    return t(messages.Category_Tooltip_With_Front(), {
      categoryName: category.name,
      count: category.count,
      frontCount: category.frontPageCount,
    });
  }

  return t(messages.Category_Tooltip_Total(), {
    categoryName: category.name,
    count: category.count,
  });
}
